// extracted by mini-css-extract-plugin
export default {"dialog":"SaveDialog_dialog__OgrPQ","buttons":"SaveDialog_buttons__nNzZp"};